import { Text } from '@kanda-libs/ks-design-library';

interface ActionRequiredProps {
  label?: string;
  hiddenOnMobile?: boolean;
}

const ActionRequired = ({ label, hiddenOnMobile }: ActionRequiredProps) => (
  <Text
    className={`${
      hiddenOnMobile ? 'hidden md:block' : 'block'
    } text-14-22-em text-lavender-300 mb-2`}
    text={label as string}
  />
);

ActionRequired.defaultProps = {
  label: 'Action required',
  hiddenOnMobile: false,
};

export default ActionRequired;
